<template>
  <div class="footer-menu-profile-select-wrapper">
    <transition name="slide">
      <div class="footer-menu-profile-select">
        <div class="footer-menu-profile-select__header flex align-center space-between pa-3">
          <div class="flex align-center">
            <Avatar
              :label="userFirstLetter"
              shape="circle"
            />
            <div class="ml-2 bold-600">
              {{ userEmail }}
            </div>
          </div>
          <div
            class="pointer"
            @click="$emit('close')"
          >
            <gl-icon
              :height="12"
              name="close"
              :width="12"
            />
          </div>
        </div>

        <router-link
          v-if="isAdmin"
          class="decoration-none"
          :to="{ name: 'admin-panel' }"
        >
          <div class="footer-menu-profile-item">
            <gl-icon
              class="mr-2"
              :height="24"
              name="your-reports"
              :width="24"
            />
            <div class="">
              Admin panel
            </div>
          </div>
        </router-link>

        <div
          v-if="isMobileDevice() && !isPWAInstalled()"
          class="footer-menu-profile-item"
          @click="installHandler"
        >
          <gl-icon
            class="mr-2"
            :height="24"
            name="pwa-install"
            :width="24"
          />
          <div class="link-text">
            Install app
          </div>
        </div>

        <router-link
          class="decoration-none"
          :to="{ name: 'source-of-funds' }"
        >
          <div class="footer-menu-profile-item">
            <gl-icon
              class="mr-2"
              :height="24"
              name="your-reports"
              :width="24"
            />
            <div class="">
              Reports
            </div>
          </div>
        </router-link>

        <router-link
          class="decoration-none"
          :to="{ name: 'profile' }"
        >
          <div class="footer-menu-profile-item">
            <gl-icon
              class="mr-2"
              :height="24"
              name="unknown-user-transparent"
              :width="24"
            />
            <div class="">
              Profile Information
            </div>
          </div>
        </router-link>

        <router-link
          class="decoration-none"
          exact
          :to="{ name: 'landing-page', params: { section: '.nlp__faq' } }"
        >
          <div class="footer-menu-profile-item">
            <gl-icon
              class="mr-2"
              :height="24"
              name="I-Question"
              :width="24"
            />
            <div>
              FAQ
            </div>
          </div>
        </router-link>

        <div
          class="footer-menu-profile-item"
          @click="contactSupport"
        >
          <gl-icon
            class="mr-2"
            :height="24"
            name="get-help-dark"
            :width="24"
          />
          <div> Get help? </div>
        </div>

        <div
          v-if="!isB2bUser"
          class="footer-menu-profile-item pb-4 pt-4"
          @click="logoutUser"
        >
          <gl-icon
            class="mr-2"
            :height="24"
            name="logout"
            :width="24"
          />
          <div class="">
            Log Out
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// Components
import GlIcon from '@/components/gl-icon'
// Vuex
import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
// Utils
import { contactSatoshieyeSupport } from '@/utils/go-to-route'
import {checkIfIos, installPWA, isMobileDevice, isPWAInstalled, shouldSkipPWAInstallCheck} from "@/utils/pwa-support";
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'
import Avatar from "primevue/avatar";

export default {
  components: {
    Avatar,
    GlIcon,
  },
  mixins: [deviceWidthMixin],
  data() {
    return {
      showPrompt: false,
      isIos: false,
      deferredPrompt: false,
      // availableToInstall: false,
    }
  },
  computed: {
    ...mapState('user', ['userData']),
    ...mapGetters('user', ['isAdmin', 'isB2bUser']),
    userEmail() {
      return this.userData && this.userData.email
    },
    userFirstLetter() {
      return this.userEmail && this.userEmail.charAt(0).toUpperCase()
    },
  },
  watch: {
    $route() {
      this.$emit('close')
    },
  },
  mounted() {
    this.checkAvailableToInstall()
  },
  methods: {
    isPWAInstalled,
    isMobileDevice,
    ...mapActions('user', ['logout']),
    ...mapMutations({
      SET_IS_PROMPT_OPEN: 'sidebar/SET_IS_PROMPT_OPEN',
    }),
    checkIfIos,
    shouldSkipPWAInstallCheck,
    contactSatoshieyeSupport,
    checkAvailableToInstall() {
      // if (this.shouldSkipPWAInstallCheck()) return

      // this.availableToInstall = true

      if (!this.checkIfIos()) {
        window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
      }
    }
    ,
    installHandler() {
      this.SET_IS_PROMPT_OPEN(true)
      // if (this.checkIfIos()) {
      //   this.SET_IS_PROMPT_OPEN(true)
      // } else {
      //   this.SET_IS_PROMPT_OPEN(false)
      //   this.handlePwaInstall()
      // }
    },
    handleBeforeInstallPrompt(e) {
      e.preventDefault()
      this.deferredPrompt = e
    },
    async handlePwaInstall() {
      if (this.shouldSkipPWAInstallCheck()) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Installation Unavailable',
          detail: 'The app is already installed',
          life: 4000,
        })

        return
      }

      if (!this.deferredPrompt) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Installation Unavailable',
          detail: 'Your browser does not support installing this app.',
          life: 4000,
        })

        return
      }

      await installPWA({
        deferredPrompt: this.deferredPrompt,
        onCleanup: () => {
          this.cleanup()
        }
      })
    },
    cleanup() {
      this.showPrompt = false
    },
    logoutUser() {
      this.logout()
      window.location.assign('/')
    },

    contactSupport() {
      this.contactSatoshieyeSupport()
      this.$emit('close')
    },
  },
}
</script>

<style>
.footer-menu-profile-select-wrapper {
  position: absolute;
  background: rgba(9, 21, 64, 0.4);
  bottom: 0;
  left: 0;
  width: var(--full-width);
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-menu-wrapper-with-banner .footer-menu-profile-select-wrapper {
  bottom: calc(var(--report-banner-height) * -1);
}
.footer-menu-profile-select {
  background: var(--white);
  width: var(--full-width);
  border-radius: 24px 24px 0 0;
}

.footer-menu-profile-item {
  display: flex;
  align-items: center;
  padding: 24px 16px;
  color: var(--dark);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s linear;
}
.footer-menu-profile-item:hover {
  background: var(--cotton-grey-f-5);
  transition: all 0.2s linear;
}
.router-link-active .footer-menu-profile-item {
  background: var(--light-grey-d-b);
}

.footer-menu-profile-select__header {
  border-bottom: 1px solid var(--Basic-200, rgba(9, 21, 64, 0.08));
}
</style>
